<template>
  <v-flex xs12>
    <v-timeline dense>
      <v-timeline-item v-for="(event,index) in eventsForBooking( booking )" color="#5c84be" small>
        <p style="color: #5c84be; font-size: 13px;">
          <b>{{event.name}}</b>
        </p>
        <p style="font-size: 13px;">{{formatDate(event.date, "HH:mm DD/MM/YYYY")}}</p>
        <p v-if="event.description != null" style="font-size: 13px;">{{event.description}}</p>
      </v-timeline-item>
    </v-timeline>
  </v-flex>
</template>

<script>
import moment from "moment";

export default {
  name: "Timeline",
  model: {
    prop: "content",
    event: "input"
  },
  components: {},
  props: {
    booking: Object
  },
  computed: {},
  methods: {
    bookingCancellationReason: function(booking) {
      var reason = "";

      reason += booking.cancellation_type;

      if (booking.cancellation_reason != null) {
        reason += ", " + booking.cancellation_reason;
      }

      if (booking.cancellation_description != null) {
        reason += ", " + booking.cancellation_description;
      }

      return reason;
    },
    eventsForBooking: function(booking) {
      var events = [];

      if (booking.id == null) {
        return [];
      }

      console.log("Events for booking");

      events.push({
        date: moment(booking.created_at, "DD/MM/YYYY HH:mm").toDate(),
        name:
          "Booking Created via " +
          booking.booking_type +
          (booking.booked_by != null
            ? " (Booked by " + booking.booked_by + ")"
            : ""),
        description: null
      });

      if (booking.accept_time != null) {
        events.push({
          date: moment(booking.accept_time, "DD/MM/YYYY HH:mm").toDate(),
          name:
            "Driver " +
            booking.driver.name +
            " Accepted Trip (dispatched by " +
            (booking.dispatched_by == null
              ? "Auto Dispatch"
              : booking.dispatched_by) +
            ")",
          description: null
        });
      }

      if (booking.asap == false) {
        events.push({
          date: booking.pickup_datetime.toDate(),
          name: "Pickup Time",
          description: null
        });
      }

      if (booking.arrived_time != null) {
        events.push({
          date: moment(booking.arrived_time, "DD/MM/YYYY HH:mm").toDate(),
          name: "Driver Arrived at pickup",
          description: null
        });
      }

      if (booking.pob_time != null) {
        events.push({
          date: moment(booking.pob_time, "DD/MM/YYYY HH:mm").toDate(),
          name: "Passenger(s) on board",
          description: null
        });
      }

      if (booking.finished_time != null) {
        if (booking.state == "cancelled") {
          events.push({
            date: moment(booking.finished_time, "DD/MM/YYYY HH:mm").toDate(),
            name: "Booking Cancelled",
            description: this.bookingCancellationReason(booking)
          });
        } else {
          events.push({
            date: moment(booking.finished_time, "DD/MM/YYYY HH:mm").toDate(),
            name: "Booking Completed",
            description: null
          });
        }
      }

      console.log("Events: " + events.length);

      events.sort(function(a, b) {
        return a.date - b.date;
      });

      return events;
    },
    formatDate: function(e, f) {
      return moment(e).format(f);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}

tr[role="row"] {
  height: 64px !important;
}

.e-resource-column-wrap tr {
  height: 64px !important;
}


</style>
